export const prePrimaryFaq=
[
  {
    question: "What age group is eligible for Nursery admissions at Rankridge?",
    answer: "Nursery admissions are open for children aged 2.5 to 3.5 years."
  },
  {
    question: "Does Rankridge offer both academics and extracurricular activities?",
    answer: "Yes, our curriculum balances learning, play, sports, and creative arts."
  },
  {
    question: "Is transportation available?",
    answer: "Yes, we provide safe and reliable school transport services across Hyderabad."
  }
]

export const primary=[
  {
    question: "What grades are offered at Rankridge Primary School?",
    answer: "We offer Grade 1 to Grade 5 as part of our primary school program."
  },
  {
    question: "Is Rankridge affiliated with CBSE?",
    answer: "Yes, we follow a CBSE-aligned curriculum for holistic academic growth."
  },
  {
    question: "Are extracurricular activities included in the primary program?",
    answer: "Yes, students participate in art, music, dance, sports, and coding alongside academics."
  }
]


export const middleToSecondary=[
  {
    question: "Which grades are covered under Rankridge Middle to Secondary School?",
    answer: "We offer Grade 6 to Grade 10 with CBSE/ICSE curriculum."
  },
  {
    question: "Does Rankridge offer competitive exam preparation?",
    answer: "Yes, we integrate preparation for Olympiads, NTSE, and talent exams into the regular school timetable."
  },
  {
    question: "Are sports and extracurricular activities included?",
    answer: "Absolutely — our program balances academics with sports, arts, and life skills."
  }
]

export const neetiitjee=[
  {
    question: "Which grades are eligible for the IIT-JEE & NEET Foundation Program?",
    answer: "Our program is designed for students from Grade 6 to Grade 10."
  },
  {
    question: "Is the program suitable for both IIT-JEE and NEET aspirants?",
    answer: "Yes, we provide subject-focused preparation for both engineering and medical entrance exams."
  },
  {
    question: "Does Rankridge also prepare students for Olympiads and NTSE?",
    answer: "Absolutely — our foundation curriculum includes Olympiad and NTSE coaching."
  }
]

export const cbseSchool=[
  {
    question: "Which grades are covered under Rankridge CBSE School?",
    answer: "We offer the CBSE curriculum from Grade 1 to Grade 10."
  },
  {
    question: "Do you also prepare students for competitive exams?",
    answer: "Yes — along with CBSE academics, we provide training for Olympiads, NTSE, and other talent exams."
  },
  {
    question: "What co-curricular activities are offered?",
    answer: "We provide sports, arts, music, dance, drama, debate, and leadership activities for all-round development."
  }
]


export const stateBoard=[
  {
    question: "Which grades are covered under the Rankridge State Board program?",
    answer: "We offer State Board curriculum from Grade 1 to Grade 10."
  },
  {
    question: "Do you also prepare students for competitive exams?",
    answer: "Yes — our program integrates preparation for IIT-JEE, NEET, EAMCET, Olympiads, and NTSE along with the State Board syllabus."
  },
  {
    question: "How do you ensure students perform well in SSC exams?",
    answer: "We follow regular testing, detailed revision plans, and personalized mentoring to ensure top results."
  }
]


